import { devfolioFetch } from "./devfolioApi";

/**
 * Fetches employees from BigQuery (directory_employees) filtered by departments.
 * @param {string[]} departments - Array of department names to filter by
 * @returns {Promise<{ok: boolean, employees: Array}>}
 */
export async function getEmployeesByDepartments(departments = []) {
  try {
    if (!departments || departments.length === 0) {
      return { ok: true, employees: [] };
    }
    const params = new URLSearchParams({
      departments: departments.join(","),
    });
    const data = await devfolioFetch(`employees?${params.toString()}`);
    const employees = Array.isArray(data.employees) ? data.employees : [];
    return { ok: data.ok === true, employees };
  } catch (err) {
    console.error("Error fetching employees by departments:", err);
    return { ok: false, employees: [] };
  }
}
